  import Enum from './enum'

class BidRuleType extends Enum
{
  constructor(value) {
    super(value);
  }
}

BidRuleType.init({
  A: 'A',
  A1: 'A1',
  B: 'B',
  B1: 'B1',
  B2: 'B2',
  C: 'C',
  C1: 'C1',
  C2: 'C2',
  C3: 'C3',
  C4: 'C4',
  C5: 'C5'
}, {
    A: 'A',
    A1: 'A1',
    B: 'B',
    B1: 'B1',
    B2: 'B2',
    C: 'C',
    C1: 'C1',
    C2: 'C2',
    C3: 'C3',
    C4: 'C4',
    C5: 'C5'
});

export default BidRuleType;
